module.exports = __webpack_public_path__ + "static/media/TM.c426102c.png";